import * as React from "react"
import * as styles from "./styles.module.scss"
import { IJourneyDetails } from "config/journeys"
import JourneyItem from "../JourneyItem"
import clock from "images/icon-clock.svg"
import certificate from "images/icon-certificate.svg"
import person from "images/icon-person.svg"

export interface JourneyDetailsProps {
  details: IJourneyDetails
}

const JourneyDetails: React.FC<JourneyDetailsProps> = ({ details }) => {
  return (
    <div className={styles.journeyDetails}>
      <div className={styles.pagePadding}>
        <div className={styles.list}>
          {details.timing.length > 0 && (
            <JourneyItem
              list={details.deliverables}
              heading="How long it takes"
              imgAlt="Clock"
              imgSrc={clock}
            />
          )}

          <JourneyItem
            list={details.deliverables}
            heading="What you’ll get"
            imgAlt="Certificate"
            imgSrc={certificate}
          />

          <JourneyItem
            list={details.customer}
            heading="Who this is for"
            imgAlt="Person"
            imgSrc={person}
          />
        </div>
      </div>
    </div>
  )
}

export default JourneyDetails
